<div class="dialog-actions d-flex justify-content-end" mat-dialog-actions>
  <ng-content></ng-content>
</div>
